<div role="tabpanel">

  <div class="tab-content tab-content-top">
    {{#each tabs}}
      <div role="tabpanel" class="tab-pane {{tab_pane_class}} {{#if (equal @index ../default)}}active{{/if}}" id="{{id}}_pane_top">
        {{#if blocks}}
          <div data-region="{{../cid}}-tabs-{{@index}}-blocks"></div>
        {{/if}}
      </div>
    {{/each}}
  </div>
  <ul class="tabs" role="tablist">
    {{#each tabs}}
      <li role="presentation" class="tab {{tab_class}} {{#if (equal @index ../default)}}active{{/if}}">
        <a href="#{{id}}_pane" data-target="#{{id}}_pane, #{{id}}_pane_top" id="{{id}}" role="tab" data-toggle="tab" aria-expanded="{{../default}}">{{t text}}</a>
      </li>
    {{/each}}
  </ul>
  <div class="tab-content tab-content-bottom">
    {{#each tabs}}
      <div role="tabpanel" class="tab-pane {{tab_pane_class}} {{#if (equal @index ../default)}}active{{/if}}" id="{{id}}_pane" tabindex="-1" aria-labelledby="{{id}}">
        {{#if blocks}}
          <div data-region="{{../cid}}-tabs-{{@index}}-blocks"></div>
        {{/if}}
      </div>
    {{/each}}
  </div>
</div>
